<template>
<div class="chapter">
<div class="inner_page">
      ﻿


<link href="styles/default.css" rel="stylesheet" type="text/css"/>
<title>Aunt Bee’s Delightful Desserts: More Than 350 Recipes from Mayberry, Americas’s Friendliest Town</title>
<p class="ctr" id="pz18-2"><a href="#/contents#RR_15" id="CC_15"> Russian Diplomat Tea</a></p>
<p class="tx6" id="pz18-3"><i> A flow-through breakthrough. </i></p>
<p class="tx5" id="pA91"><b> 4 small tea bags </b></p>
<p class="tx5" id="pA8C"><b> ½ gallon water </b></p>
<p class="tx5" id="pAXcq"><b> 1 teaspoon whole cloves </b></p>
<p class="tx5" id="pAxn"><b> 1 stick cinnamon </b></p>
<p class="tx5" id="pAveq"><b> 2 cups sugar </b></p>
<p class="tx5" id="AjNB"><b> 1 cup orange juice </b></p>
<p class="tx5" id="AId"><b> ½ cup lemon juice </b></p>
<p class="tx5" id="ASaA"><b> 8 cups water </b></p>
<p class="tx1" id="pAiQY"><span class="dcap">P</span>ut tea bags in water. Add remaining ingredients and let come to a boil but do not boil. Simmer for 30 minutes. Very good reheated.</p>
<p class="tx" id="pAy_"> Makes about ¾ gallon.</p>
<p class="txrr" id="pAJ8"> <i>Toni and Neal Brower—Lewisville, North Carolina</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter15.vue?56956d53